import { Stack, Tabs } from "expo-router";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { QendoIcon } from "~/components/QendoIcon";
import { useTheme } from "~/providers/ThemeProvider";

export const unstable_settings = {
    initialRouteName: "dashboard",
};

export default function DashboardLayout() {
    const { colours } = useTheme();
    const insets = useSafeAreaInsets();

    return (
        <>
            <Stack.Screen options={{ headerShown: false }} />
            <Tabs
                screenOptions={{
                    headerShown: false,
                    tabBarActiveTintColor: colours.icon.selected,
                    tabBarInactiveTintColor: colours.icon.tertiary,
                    tabBarHideOnKeyboard: true,
                    tabBarStyle: {
                        position: "absolute",
                        paddingLeft: 16,
                        paddingRight: 16,
                        height: 80 + insets.bottom,
                        backgroundColor: colours.background.primary,
                    },
                }}
            >
                <Tabs.Screen
                    name="dashboard"
                    options={{
                        title: "Home",
                        tabBarIcon: ({ color }) => <QendoIcon name="home" size={18} color={color} />,
                    }}
                />
                <Tabs.Screen
                    name="calendar"
                    options={{
                        title: "Calendar",
                        tabBarIcon: ({ color }) => <QendoIcon name="calendar" size={18} color={color} />,
                    }}
                />
                <Tabs.Screen
                    name="resources"
                    options={{
                        title: "Resources",
                        tabBarIcon: ({ color }) => <QendoIcon name="resources" size={18} color={color} />,
                    }}
                />
                <Tabs.Screen
                    name="more"
                    options={{
                        title: "More",
                        tabBarIcon: ({ color }) => <QendoIcon name="menu" size={18} color={color} />,
                    }}
                />
            </Tabs>
        </>
    );
}
